export const PREMIUM_OFFERING_ID = 'ofrng8f560a69e5';
export const PREMIUM_ENTITLEMENT_ID = 'entl877a8b3526';

export const REVENUECAT_CONFIG = {
  ios: {
    apiKey: 'appl_hSztWdkfPnDqvOFmOnBEbKmGLzD',
    offeringId: PREMIUM_OFFERING_ID,
    entitlementId: PREMIUM_ENTITLEMENT_ID
  },
  android: {
    apiKey: 'goog_ukBBfNPtzGdKvoHuDdICitrQiLq',
    offeringId: PREMIUM_OFFERING_ID,
    entitlementId: PREMIUM_ENTITLEMENT_ID
  },
  web: {
    apiKey: process.env.EXPO_PUBLIC_REVENUECAT_WEB_API_KEY || '',
    offeringId: PREMIUM_OFFERING_ID,
    entitlementId: PREMIUM_ENTITLEMENT_ID,
    purchaseLink: __DEV__
      ? (process.env.EXPO_PUBLIC_RC_PURCHASE_LINK_SANDBOX || '')
      : (process.env.EXPO_PUBLIC_RC_PURCHASE_LINK_PROD || ''),
  }
};

export const DEVELOPMENT_CONFIG = {
  useSandbox: __DEV__,
  debugLogging: __DEV__ || process.env.EXPO_PUBLIC_RC_DEBUG === 'true'
};

export const PLAY_STORE_PACKAGE_NAME = 'com.virgoplay.hekaya';